import * as React from 'react';
import Autosuggest from 'react-autosuggest';
import { Link } from 'react-router-dom';
import TagsInput from 'react-tagsinput';
import { Formik, FieldArray } from 'formik';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import * as _ from 'lodash';
import * as Util from 'src/util';
import { Input, InputAddon, Textarea, Checkbox } from './../Shared/BsInput';
import QuillEditor from 'src/components/Shared/QuillEditor';
import InputErrorClass from './../Shared/InputErrorClass';
import { CONTENT_TYPES, LANGUAGES } from 'src/globals';
import { DestinationsAutocomplete } from 'lesamis-react-components';
import ContentsSearchModal from 'src/containers/Shared/ContentsSearchModal';
import LesImages from 'src/containers/Shared/Images/';
import 'react-tagsinput/react-tagsinput.css';

const RenderForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
  setFieldValue,
  toggleModal,
  modalOpened,
  contentsSubtypes,
  slugType,
  setSlugType,
  tags,
}: any) => {
  function autocompleteRenderInput ({ addTag, ...props }: any) {
    const handleOnChange = (e: any, { newValue, method }: any) => {
      if (method === 'enter') {
        e.preventDefault()
      } else {
        props.onChange(e)
      }
    }

    const inputValue = (props.value && props.value.trim().toLowerCase()) || '';

    const suggestions = tags.filter((tag: any) => {
      return tag.name.toLowerCase().includes(inputValue.toLowerCase());
    });

    return (
      <Autosuggest
        ref={props.ref}
        suggestions={suggestions}
        shouldRenderSuggestions={(value: any) => value && value.trim().length > 0}
        getSuggestionValue={(s: any) => s.slug}
        renderSuggestion={(s: any) => <span style={{ cursor: 'pointer' }}>{s.name}</span>}
        inputProps={{...props, onChange: handleOnChange}}
        onSuggestionSelected={(e: any, { suggestion }: any) => {
          addTag(suggestion.slug)
        }}
        onSuggestionsClearRequested={() => { console.log('a'); }}
        onSuggestionsFetchRequested={() => { console.log('a'); }}
      />
    )
  }

  const onContentSelect = (content: any) => {
    values.ContentTranslations.forEach((translation: any, index: number) => {
      const matching = content.ContentTranslations
        .find((ct: any) => ct.language === translation.language);

      const parentSlug = !matching || !matching.slug
        ? ''
        : matching.slug;
      setFieldValue(`ContentTranslations.${index}.${slugType}`, parentSlug);
    });

    toggleModal();
  };

  return (
    <div>
      <ContentsSearchModal
        opened={modalOpened}
        toggleModal={toggleModal}
        onSelect={onContentSelect}
      />

      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="row">
          <div className="col">
            <FieldArray
              name="ContentTranslations"
              render={(arrayHelpers) => (
                <Tabs className="nav-fill" style={{ cursor: 'pointer' }}>
                  <TabList>
                    {
                      values.ContentTranslations.map((translation: any, index: number) => (
                        <Tab key={index}>{LANGUAGES[translation.language]}</Tab>
                      ))
                    }
                  </TabList>
                  {
                    values.ContentTranslations.map((translation: any, index: number) => (
                      <TabPanel key={index} className="p-2">
                        <InputAddon
                          label={`Slug padre ${translation.language}`}
                          type="text"
                          name={`ContentTranslations.${index}.parent_slug`}
                          onChange={handleChange}
                          onClick={() => {
                            setSlugType('parent_slug');
                            toggleModal();
                          }}
                          value={translation.parent_slug}
                          errors={errors}
                        />
                        <InputAddon
                          label={`Slug hijo ${translation.language}`}
                          type="text"
                          name={`ContentTranslations.${index}.child_slug`}
                          onChange={handleChange}
                          onClick={() => {
                            setSlugType('child_slug');
                            toggleModal();
                          }}
                          value={translation.child_slug}
                          errors={errors}
                        />
                        <Input
                          label={`Titulo ${translation.language}`}
                          type="text"
                          name={`ContentTranslations.${index}.title`}
                          onChange={handleChange}
                          value={translation.title}
                          errors={errors}
                        />
                        {
                          !!translation.slug &&
                          <Input
                            label={`Slug ${translation.language}`}
                            type="text"
                            name={`ContentTranslations.${index}.slug`}
                            onChange={handleChange}
                            value={translation.slug}
                            errors={errors}
                          />
                        }
                        <QuillEditor
                          label={`Cuerpo ${translation.language}`}
                          value={translation.body}
                          onChange={(value: any) => {
                            setFieldValue(`ContentTranslations.${index}.body`, value);
                          }}
                        />
                        <QuillEditor
                          label={`Descripcion ${translation.language}`}
                          value={translation.longDescription}
                          onChange={(value: any) => {
                            setFieldValue(`ContentTranslations.${index}.longDescription`, value);
                          }}
                        />
                        <div className="row">
                          <div className="col">
                            <Input
                              label={`Titulo meta ${translation.language}`}
                              type="text"
                              name={`ContentTranslations.${index}.meta.title`}
                              onChange={handleChange}
                              value={translation.meta.title}
                              errors={errors}
                            />
                          </div>
                          <div className="col">
                            <Input
                              label={`Keywords meta ${translation.language}`}
                              type="text"
                              name={`ContentTranslations.${index}.meta.keywords`}
                              onChange={handleChange}
                              value={translation.meta.keywords}
                              errors={errors}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <Textarea
                              label={`Descripcion meta ${translation.language}`}
                              type="text"
                              name={`ContentTranslations.${index}.meta.description`}
                              onChange={handleChange}
                              value={translation.meta.description}
                              errors={errors}
                              rows="4"
                            />
                          </div>
                          <div className="col">
                            <Input
                              label={`Canonical ${translation.language}`}
                              type="text"
                              name={`ContentTranslations.${index}.meta.canonical`}
                              onChange={handleChange}
                              value={translation.meta.canonical}
                              errors={errors}
                            />
                          </div>
                        </div>
                      </TabPanel>
                    ))
                  }
                </Tabs>
              )}
            />
          </div>
          <div className="col">
            <div className="form-group">
              <label>Destino</label>
              <DestinationsAutocomplete
                defaultSelected={_.isEmpty(values.destination) ? [] : [values.destination]}
                settings={{
                  emptyOnSelect: false,
                  clearable: true,
                  endpoint: 'autocompleteFull'
                }}
                onSelected={(selected: any) => {
                  if (!selected) {
                    return;
                  }

                  setFieldValue('destination', {
                    id: selected.id,
                    name: selected.name,
                    slug: selected.slug || selected.name,
                    code: selected.code,
                  });
                }}
                onEmpty={() => {
                  setFieldValue('destination', {});
                }}
                renderOption={(option: any, i: number) => {
                  if (option.type === 'CITY') {
                    return (<div key={i}>{option.name}, {option.Country.name}</div>);
                  }

                  return (<div key={i}>{option.name}</div>);
                }}
              />
              {errors.destination && <p className="invalid-feedback">{errors.destination}</p>}
            </div>
            <div className="form-group">
              <label>Tipo</label>
              <select
                className={InputErrorClass({ errors, name: 'type' })}
                name="type"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.type}
              >
                {
                  Object.keys(CONTENT_TYPES).map((key: string, i: number) => {
                    return (
                      <option key={i} value={key}>{CONTENT_TYPES[key]}</option>
                    );
                  })
                }
              </select>
              {errors.type && <p className="invalid-feedback">{errors.type}</p>}
            </div>
            <div className="form-group">
              <label>Subtipo</label>
              <select
                className={InputErrorClass({ errors, name: 'subtype_id' })}
                name="subtype_id"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.subtype_id}
              >
                <option value="">Indistinto</option>
                {
                  contentsSubtypes.map((cst: any, i: number) => {
                    return (<option key={i} value={cst.id}>{cst.name}</option>);
                  })
                }
              </select>
            </div>
            <div className="form-group">
              <label>Buscador</label>
              <select
                className={InputErrorClass({ errors, name: 'search' })}
                name="search"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.search}
              >
                <option value="">Ninguno</option>
                <option value="test">Test</option>
              </select>
              {errors.search && <p className="invalid-feedback">{errors.search}</p>}
            </div>
            <div className="form-group">
              <label>Banner</label>
              <div className="border border-secondary p-1">
                <div className="row">
                  <div className="col">
                    {
                      values.banner &&
                      <img src={`${process.env.REACT_APP_IMAGES_BASE_URL}r/${values.banner.bucket}/150x150/${values.banner.name}`} />
                    }
                  </div>
                  <div className="col text-right">
                    <LesImages
                      onSelected={(selected: any) => {
                        if (!selected || !selected.length) {
                          return;
                        }

                        setFieldValue('banner', {
                          name: selected[0].name,
                          bucket: selected[0].bucket,
                        });
                      }}
                    />
                    <a href="javascript:void(0)" onClick={() => setFieldValue('banner', '')}>
                      Vaciar
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <label>Icono</label>
              <div className="border border-secondary p-1">
                <div className="row">
                  <div className="col">
                    {
                      values.icon &&
                      <img src={`${process.env.REACT_APP_IMAGES_BASE_URL}r/${values.icon.bucket}/150x150/${values.icon.name}`} />
                    }
                  </div>
                  <div className="col text-right">
                    <LesImages
                      onSelected={(selected: any) => {
                        if (!selected || !selected.length) {
                          return;
                        }

                        setFieldValue('icon', {
                          name: selected[0].name,
                          bucket: selected[0].bucket,
                        });
                      }}
                    />
                    <a href="javascript:void(0)" onClick={() => setFieldValue('icon', '')}>
                      Vaciar
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <hr/>
            <div className="form-group">
              <label>Tags</label>
              <TagsInput
                renderInput={autocompleteRenderInput}
                value={values.tags}
                onChange={(tt: string[]) => {
                  const allowed = tt.filter((t: any) => {
                    return tags.findIndex((tag: any) => tag.slug === t) !== -1;
                  });

                  setFieldValue('tags', allowed);
                }}
                addKeys={[9, 188]}
                onlyUnique={true}
              />
            </div>
            <div className="form-group">
              <label>Fechas</label>
              <TagsInput
                value={values.ContentDates}
                name="contentDates"
                onChange={(tt: string[]) => {
                  setFieldValue('ContentDates', tt);
                }}
                addKeys={[9, 188]}
                onlyUnique={true}
                tagDisplayProp="date"
                validationRegex={/^(\d{4})-(\d{2})-(\d{2})$/}
                inputProps={{
                  className: 'react-tagsinput-input',
                  placeholder: 'AAAA-MM-DD',
                }}
              />
            </div>
            <div className="row">
              <div className="col">
                <Checkbox
                  name="foreigners"
                  label="Extranjeros"
                  onChange={handleChange}
                  value={values.foreigners}
                  checked={values.foreigners}
                />
              </div>
              <div className="col">
                <Checkbox
                  name="active"
                  label="Activo"
                  onChange={handleChange}
                  value={values.active}
                  checked={values.active}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="form-group text-right">
          <button type="submit" className="btn btn-lg btn-dark" disabled={isSubmitting}>
            GUARDAR
          </button>
        </div>
      </form>
    </div>

  );
}

export default class ContentForm extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      modalOpened: false,
      slugType: null,
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.setSlugType = this.setSlugType.bind(this);
  }

  public toggleModal() {
    this.setState({ modalOpened: !this.state.modalOpened });
  }

  public setSlugType(type: string) {
    this.setState({ slugType: type });
  }

  public render() {
    const { onSubmit, loading, contentId, contentsSubtypes }: any = this.props;
    const initialValues = Util.replaceNullWithEmptyString(this.props.content);

    return (
      <div className="card mb-5">
        <div className="card-header bg-primary text-white">
          <h3 className="mb-0">
            <i className="fa fa-pencil-square"></i> Contenidos
            {
              contentId &&
              <Link className="btn btn-light pull-right" to={`/modulos/${contentId}`}>
                <i className="fa fa-list"></i> Modulos
              </Link>
            }
          </h3>
        </div>
        <div className="card-body">
          {
            !loading && <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              onSubmit={
                async (values: any, { setSubmitting, setErrors }: any) => {
                  try {
                    const cleanValues = _.pick(_.cloneDeep(values), [
                      'ContentDates', 'ContentTranslations', 'type', 'banner',
                      'icon', 'active', 'search', 'foreigners', 'destination',
                      'tags', 'subtype_id',
                    ]);
                    cleanValues.ContentTranslations = cleanValues.ContentTranslations
                      .map((translation: any) => _.pick(translation, [
                        'language', 'title', 'meta', 'body', 'longDescription',
                        'parent_slug', 'slug', 'child_slug',
                      ]));

                    await onSubmit(Util.replaceEmptyStringWithNull(cleanValues));
                  } catch (err) {
                    if (err.response.data.errors) {
                      setErrors(err.response.data.errors);
                    }

                    setSubmitting(false);
                  }
                }
              }
              render={(formikProps: any) =>
                <RenderForm
                  { ...formikProps }
                  { ...{
                    contentsSubtypes,
                    toggleModal: this.toggleModal,
                    modalOpened: this.state.modalOpened,
                    slugType: this.state.slugType,
                    setSlugType: this.setSlugType,
                    tags: this.props.tags,
                  }}
                />
              }
            >
            </Formik>
          }

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Content/form.tsx